import { render, staticRenderFns } from "./ColumnsGapProperty.vue?vue&type=template&id=3466a540&"
import script from "./ColumnsGapProperty.vue?vue&type=script&lang=js&"
export * from "./ColumnsGapProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports